import './DayCaption.css'

import React from 'react'

import CalendarIcon from '../assets/svg/CalendarIcon'
import InlineIconWrapper from './InlineIconWrapper'

const DayCaption = ({ dateString, dayName }) => (
  <div className="ScheduleTable-dayLabel">
    <InlineIconWrapper iconComponent={CalendarIcon}>
      {dateString}, <span className="ScheduleTable-dayName">{dayName}</span>
    </InlineIconWrapper>
  </div>
)

export default DayCaption



// WEBPACK FOOTER //
// ./src/components/DayCaption.js